import { DOMParser } from 'hubspot-prosemirror/pm/model';
import { EditorView } from 'hubspot-prosemirror/pm/view';
import { EditorState, Transaction } from 'hubspot-prosemirror/pm/state';
import { convertToPlaintextState } from '../../utils/plaintextUtils';

export type ContentAssistantSlashPluginState = {
  dropdownActive: boolean;
  popoverActive: boolean;
  searchTerm: string;
  searchTextStartPos: number;
  currentCursorPos: number;
  currentDropdownIndex: number;
};

export const initContentAssistantSlashPluginState = () => {
  return {
    dropdownActive: false,
    popoverActive: false,
    searchTerm: '',
    searchTextStartPos: 0,
    currentCursorPos: 0,
    currentDropdownIndex: 0,
  };
};

export function mapEditorContext(state: EditorState) {
  const plain = convertToPlaintextState(state);

  const precedingText = plain.doc.textBetween(0, plain.selection.from, '\n');
  const selectedText = plain.doc.textBetween(
    plain.selection.from,
    plain.selection.to,
    '\n'
  );
  const rest = plain.doc
    .textBetween(plain.selection.from, plain.doc.content.size, '\n')
    .replace(selectedText, `<<${selectedText}>>`);

  return `${precedingText}${rest}`;
}

export const onInsertSlashContent = (
  text: string,
  view: EditorView,
  state: ContentAssistantSlashPluginState,
  commandId: string,
  tr: Transaction
) => {
  let node;
  switch (commandId) {
    case 'inbox_write_for_me_v1': {
      node = view.state.schema.text(text);
      break;
    }
    default: {
      const html = `${text.replaceAll('\n', '<br>')}`;
      const parser = new window.DOMParser();
      const element = parser.parseFromString(html, 'text/html');
      node = DOMParser.fromSchema(view.state.schema).parse(element.body);
    }
  }
  tr.replaceWith(state.searchTextStartPos, state.currentCursorPos, node);
  view.dispatch(tr);
};

export const getSelectedCommandParamsForSlash = (
  selectedCommand: string,
  __view: EditorView,
  __state: ContentAssistantSlashPluginState
): { [key: string]: string } => {
  const parameters: { [key: string]: string } = {};

  switch (selectedCommand) {
    case 'inbox_write_for_me_v1': {
      const title = document.querySelector(
        '#composition-title'
      ) as HTMLInputElement;

      if (title && title.value) {
        parameters.title = title.value;
      }
      break;
    }
    default:
      break;
  }
  return parameters;
};
